import type { StylePreset } from '../types'

export const STYLE_PRESETS: StylePreset[] = [
  {
    id: 'oem-plus',
    name: 'OEM+',
    description: 'Factory-refined aesthetics with tasteful upgrades. The purist\'s choice.',
    partialConfig: {
      paintColor: '#1c3f6e',
      paintFinish: 'metallic',
      secondaryColor: '#2a2a2a',
      rimColor: '#c0c0c0',
      caliperColor: '#1a1a1a',
      interiorColor: '#1a1a1a',
      frontBumper: 'front_bumper_mtech1',
      frontLip: 'none',
      rearBumper: 'rear_bumper_mtech2_single',
      wheels: 'rim_style_37',
      headlights: 'stock',
      sideVents: 'none',
      mirrors: 'stock',
      spoiler: 'spoiler_stock',
      roof: 'roof',
      badge: 'badge_330i',
      windowTint: 'none',
      rideHeight: -0.02,
    },
  },
  {
    id: 'clean-daily',
    name: 'Clean Daily',
    description: 'Understated presence with modern touches. Turns heads without trying.',
    partialConfig: {
      paintColor: '#1a1a1a',
      paintFinish: 'satin',
      secondaryColor: '#0d0d0d',
      rimColor: '#a8a8a8',
      caliperColor: '#333333',
      interiorColor: '#1a1a1a',
      frontBumper: 'front_bumper_mtech1',
      frontLip: 'none',
      rearBumper: 'rear_bumper_mtech2_single',
      wheels: 'rim_bbs_chr',
      headlights: 'projectors',
      sideVents: 'none',
      mirrors: 'm3',
      spoiler: 'spoiler_roof',
      roof: 'roof',
      badge: 'badge_330i',
      windowTint: '35',
      rideHeight: -0.04,
    },
  },
  {
    id: 'aggressive-street',
    name: 'Aggressive Street',
    description: 'Bold stance and sharp lines. Built to intimidate on sight.',
    partialConfig: {
      paintColor: '#0d0d0d',
      paintFinish: 'gloss',
      secondaryColor: '#0d0d0d',
      rimColor: '#1a1a1a',
      caliperColor: '#cc0000',
      interiorColor: '#0d0d0d',
      frontBumper: 'front_bumper_zhp',
      frontLip: 'front_lip',
      rearBumper: 'rear_bumper_mtech2_dual',
      wheels: 'rim_style_135',
      headlights: 'projectors',
      sideVents: 'm_side_vents',
      mirrors: 'm3',
      spoiler: 'spoiler_ducktail',
      roof: 'roof',
      badge: 'badge_m3',
      windowTint: '15',
      rideHeight: -0.06,
    },
  },
  {
    id: 'track-inspired',
    name: 'Track-Inspired',
    description: 'Full M3 aesthetic with competition DNA. Ready for the ring.',
    partialConfig: {
      paintColor: '#ffffff',
      secondaryColor: '#0d0d0d',
      rimColor: '#1a1a1a',
      caliperColor: '#d4a017',
      interiorColor: '#0d0d0d',
      frontBumper: 'front_bumper_m3',
      frontLip: 'front_lip',
      rearBumper: 'rear_bumper_m3',
      wheels: 'rim_style_166',
      headlights: 'projectors',
      sideVents: 'm_side_vents',
      mirrors: 'm3',
      spoiler: 'spoiler_ducktail',
      roof: 'roof',
      badge: 'badge_m3',
      windowTint: '5',
      rideHeight: -0.08,
    },
  },
]